import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image" 

class HeroImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover:false,
      mobile:false
    };
  }
  componentDidMount() {
    if(window.innerWidth<768) {
      this.setState({mobile:'fade-in'});
    } 
  }
  showCursor(e) {
    var title = e.currentTarget.getAttribute('data-cursor');
    if (title) {
      document.querySelector('.floating--cursor .caption .inner').innerHTML = title;
    }
    document.querySelector('.floating--cursor').classList.add('active');
  }
  showDragCursor() {
    document.querySelector('.floating--cursor').classList.add('active-drag');
  }
  hideCursor() {
    document.querySelector('.floating--cursor').classList.remove('active');
    document.querySelector('.floating--cursor').classList.remove('active-drag');
  }
  render() {
    if(this.props.comingSoon) {
      var comingSoon = <div className="coming--soon">Coming Soon</div>;
    }
    if(this.props.showCursor) {
      return (
        <div className="hero--image pos-rel h-125 m-100 overflow-hidden flex image-will--darken image-with--caption" data-title={this.props.title}> 
          <div className="w-100 h-125 pos-rel z-2 h-100" role="presentation" onMouseEnter={this.showCursor} data-cursor="Coming Soon" onMouseLeave={this.hideCursor}></div>
          <div className="slide--marker" data-scroll data-title={this.props.title} data-scroll-call="change-slide" data-scroll-repeat="true" data-slide={this.props.slide} data-scroll-position="bottom" ></div>   
            <div className="bg-image--container">
              <div className="bg-image--container" data-scroll data-scroll-speed="-1.5">
                <GatsbyImage image={this.props.image} alt={this.props.title} className="bg-image" />
              </div>
            </div>
            {comingSoon}
        </div> 
      )
    } else {
      return (
        <div className={this.state.mobile} data-scroll>  
          <div className="hero--image pos-rel h-125 m-100 overflow-hidden flex image-will--darken image-with--caption" data-title={this.props.title}>
            <div className="slide--marker" data-scroll data-title={this.props.title} data-scroll-call="change-slide" data-scroll-repeat="true" data-slide={this.props.slide} data-scroll-position="bottom" ></div>   
              <div className="bg-image--container">
                <div className="bg-image--container" data-scroll data-scroll-speed="-1.5">
                  <GatsbyImage image={this.props.image} alt={this.props.title} className="bg-image" />
                </div>
              </div>
          </div> 
        </div> 
      )
    }
  }
} 

export default HeroImage

